<template>
  <div class="ls-nav-items">
    <div v-for="(item, idx) in items" :key="idx" :class="{ 'top-border': idx > 0 }">
      <a class="ls-nav-items--link" test-id="click" :style="styleOverride" @click="item.onClick">
        {{ item.label }}
        <LsIcon :type="item.type" size="sm" class="ls-nav-item--icon" />
      </a>
    </div>
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import { LsIcon } from '@/components/common';

export default {
  name: 'LsNavItems',
  components: {
    LsIcon,
  },
  props: {
    items: VueTypes.arrayOf(
      VueTypes.shape({
        label: VueTypes.string.isRequired,
        onClick: VueTypes.func.isRequired,
        type: VueTypes.string.isRequired,
      }).isRequired
    ).isRequired,
    styleOverride: VueTypes.string,
  },
};
</script>

<style lang="scss" scoped>
.ls-nav-items--link {
  display: flex;
  justify-content: space-between;
  padding: 9px 0;
  color: $gray-primary;
  &:hover {
    color: $special-primary-hover;
  }
}

.ls-nav-item--icon {
  margin: 3px 0 0 5px;
}

.top-border {
  border-top: 1px solid $primary-light;
}

.themed-app {
  .ls-nav-items--link {
    color: $theme-color-gray-darker;
    &:hover {
      color: $theme-color-primary-light-hover;
    }
  }
  .top-border {
    border-color: $theme-color-primary-light;
  }
}
</style>
